module.exports = __webpack_public_path__ + "a8b3346c69a411711c6f8e02acbf88c7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/leadership-comps/leadership-comp.png
 ** module id = 836
 ** module chunks = 0
 **/